import { render, staticRenderFns } from "./BarcodeScannerModal.vue?vue&type=template&id=5bb4b376&scoped=true&"
import script from "./BarcodeScannerModal.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerModal.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeScannerModal.vue?vue&type=style&index=0&id=5bb4b376&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4b376",
  null
  
)

export default component.exports